import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../notes/button/button.module';
import { ModalModule } from '../../notes/modal/modal.module';
import { LinkModule } from '../link/link.module';
import { ExternalConfigPipe, LinkConfigPipe } from './external-config.pipe';
import { SsoPaymentComponent } from './sso-payment.component';

@NgModule({
  declarations: [SsoPaymentComponent, ExternalConfigPipe, LinkConfigPipe],
  exports: [SsoPaymentComponent],
  imports: [CommonModule, ModalModule, ButtonModule, LinkModule],
})
export class SsoPaymentModule {}
